module.exports = __webpack_public_path__ + "img/society-blackbeard-avatar.51e77607.png";